/**
 * Backwards-compatibility proxy for the snapshot module.
 * The implementation has been refactored into modular components in the `src/snapshot/` directory.
 */
export * from './snapshot';
export { SeadevShedSnapshot } from './snapshot';
